import { client } from "@/hono";
import { ContentBox } from "@msuite/ui/content-box";
import { useQuery } from "@msuite/ui/query";
import type { ColumnPinningState } from "@msuite/ui/table";
import { DataTable } from "@msuite/ui/table";
import type { ClassNameProps } from "@msuite/ui/types";
import { responseHandler } from "@msuite/ui/utils";
import { uniqueArray } from "@msuite/utils/array";
import { ServicesMenu } from "./services-menu";
import { columns } from "./table-config";

/** PRops Interface */
interface ServicesProps extends ClassNameProps {
	columns?: any[];
	withContentBox?: boolean;
	initialPinningState?: Partial<ColumnPinningState>;
}

export function Services({
	columns: _columns = [],
	initialPinningState = {},
	withContentBox = true,
	className,
}: ServicesProps) {
	/** Hooks */
	const { data, queryKey, isLoading, refetch } = useQuery({
		queryKey: ["services"],
		queryFn: async () => {
			const response = await client.organizations.services.$get();
			const data = await responseHandler(response);
			return data.services;
		},
	});

	const Wrapper = withContentBox ? ContentBox : "div";

	/** Render */
	return (
		<Wrapper className={className}>
			<DataTable
				data={data as any}
				columns={columns.concat(_columns) as any}
				isLoading={isLoading}
				queryKey={queryKey}
				menu={<ServicesMenu queryKey={queryKey} />}
				refetch={refetch}
				persistenceKey="services-table"
				initialPinningState={{
					start: uniqueArray((initialPinningState.start || []).concat(["fullNumber"])),
					end: uniqueArray(initialPinningState.end || []),
				}}
			/>
		</Wrapper>
	);
}
